import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    delete_plan(postArgs) {
        let id = postArgs.plan_id;
        return axios.delete(`${apiUrl}v2/delete_plan/${id}`)
    },
    delete_plan_detail_to_recycle(postArgs) {
        return axios.post(`${apiUrl}v2/delete_plan_detail_to_recycle/`, postArgs)
    },
    modify_plan(postArgs) {
        return axios.post(`${apiUrl}v2/modify_plan/`, postArgs)
    },
    modify_plan_summary(postArgs) {
        return axios.post(`${apiUrl}v2/modify_plan_summary/`, postArgs)
    },
    modify_plan_detail_progress(postArgs) {
        return axios.post(`${apiUrl}v2/modify_plan_detail_progress/`, postArgs)
    },
    modify_plan_detail_end_date(postArgs) {
        return axios.post(`${apiUrl}v2/modify_plan_detail_end_date/`, postArgs)
    },
    publish_plan(postArgs) {
        return axios.post(`${apiUrl}v2/publish_plan/`, postArgs)
    },
    get_my_plans() {
        return axios.get(`${apiUrl}v2/get_my_plans/`)
    },
    get_my_notes() {
        return axios.get(`${apiUrl}v2/get_my_notes/`)
    },
    get_my_todos() {
        return axios.get(`${apiUrl}v2/get_my_todos/`)
    },
    get_todos_by_user(args) {
        return axios.get(`${apiUrl}v2/get_todos_by_user/`, {params: args})
    },
    get_my_todos_by_date(args) {
        return axios.get(`${apiUrl}v2/get_my_todos_by_date/`, {params: args})
    },
    get_my_plans_by_date(args) {
        return axios.get(`${apiUrl}v2/get_my_plans_by_date/`, {params: args})
    },
    get_plans_by_user(args) {
        return axios.get(`${apiUrl}v2/get_plans_by_user/`, {params: args})
    },
    get_plan_info(planId) {
        return axios.get(`${apiUrl}v2/get_plan_info/${planId}`)
    },
}